import {Component, OnInit, TemplateRef, ChangeDetectionStrategy} from '@angular/core';
import {WeightService} from '../../services/weight.service';
import {WeightModel} from '../../model/WeightModel';
import {DateUtil} from '../../util/DateUtil';
import {NgbDateStruct, NgbInputDatepicker, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ChartConfiguration, ChartType} from 'chart.js';
import {BaseChartDirective} from 'ng2-charts';
import {FormsModule} from '@angular/forms';

@Component({
    selector: 'app-mood',
    templateUrl: './weight.component.html',
    styleUrls: ['./weight.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [BaseChartDirective, FormsModule, NgbInputDatepicker]
})
export class WeightComponent implements OnInit {

  public lineChartType: ChartType = 'line';
  public weights: WeightModel[] = [];
  currentEntry: WeightModel;

  chartData: ChartConfiguration['data'] = {
    datasets: [],
  };

  public chartOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
    },
    elements: {
      line: {
        fill: false
      }
    }
  };

  constructor(
    private moodService: WeightService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.load();
  }


  load() {
    this.moodService.getAllWeightEntries().subscribe((res: WeightModel[]) => {
      this.weights = res;

      this.chartData = {
        datasets: [{
          data: res.map(m => m.weight).reverse(),
        }],
        labels: res.map(m => m.date as string).reverse(),
      };

    });
  }

  selectNew(content: TemplateRef<unknown>) {
    this.currentEntry = {} as WeightModel;
    this.currentEntry.date = DateUtil.getToday();

    this.openModal(content);
  }

  openModal(content: TemplateRef<unknown>) {

    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'})
      .result.then(() => this.save());
  }

  select(row: WeightModel, content: TemplateRef<unknown>) {
    this.currentEntry = {...row};
    this.currentEntry.date = DateUtil.stringToNgb(this.currentEntry.date as string);

    this.openModal(content);
  }

  save() {
    const moodMOdel = {...this.currentEntry};
    moodMOdel.date = DateUtil.ngbToString((moodMOdel.date) as NgbDateStruct);
    this.moodService.save(moodMOdel).subscribe(res => {
      this.load();
    });
  }
}
